<mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value" [bufferValue]="bufferValue">
</mat-progress-bar>

<div style="min-height: 400px;">
  <div class="mdl-cell mdl-cell--7-col reportsCharts">
    <div id="parentCalendarCases">
      <canvas id="calendarCases" width="100%; height: 100%"></canvas>
    </div>
  </div>
</div>

<div *ngIf="showTable"  class="mat-elevation-z8">
  <mat-table [dataSource]="calendarCasesTableData">
      <ng-container matColumnDef="case_number">
        <mat-header-cell *matHeaderCellDef> Case Number </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button mat-button color="accent" (click)="openCase(element)">
            {{element.caseSummary.case_number ? element.caseSummary.case_number : 'open' }}
          </button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="created_date">
        <mat-header-cell *matHeaderCellDef> Petition Filed </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.caseSummary.created_date | date}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="modified_date">
        <mat-header-cell *matHeaderCellDef> Last Updated </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.caseSummary.modified_date | date}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{element.caseSummary.status}}
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    <mat-paginator #paginator  [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
    </mat-paginator>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/reports/calendar-cases/calendar.cases.component.html